/***************/
/**  IMPORTS  **/
/***************/

/***********************/
/**  AMPLIFY IMPORTS  **/
/***********************/

/****************************/
/**  LOCAL/ASSETS IMPORTS  **/
/****************************/
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";
import security_icon from "../assets/security_icon.svg";
import { PageContainer,
         Header
         } from "../styles/ProfileStyles";

export default function SecurityPage(){

    return (
        <>
        <Navbar />
        <div style={{display: "flex", justifyContent: "center", flexDirection: "row"}}>
            <PageContainer>
                <div style={{display: "flex", flexDirection: "row"}}>
                    <Sidebar></Sidebar>
                    <img alt="security_icon" src={security_icon} style={{marginLeft: 30, paddingTop: "5px"}} />
                    <Header>Security Settings</Header>
                </div>
            </PageContainer>
        </div>
        </>
    )
}